export default __webpack_public_path__ + "static/persona-celebration-433d0acfccdadb2063b472cd5d91b9ff.png";